import { useState } from "react";
import {
  Grid,
  Box,
  Switch,
  Typography,
  CircularProgress,
} from "@mui/material";
import PublicOffIcon from "@mui/icons-material/PublicOff";

import GlassCard from "../General/GlassCard";
import CardHeader from "../General/CardHeader";
import { useToast } from "../../context/ToastContext";
import { useAuth } from "../../context/AuthContext";
import { updateSettings } from "../../services/SettingService";

export default function GeneralSettings() {
  const { showToast } = useToast();
  const { onlineQueriesEnabled, setPublicSettings, hasPermission } = useAuth();

  const canEdit = hasPermission("administrar configuracion");
  const [saving, setSaving] = useState(false);

  const toggleOnlineQueries = async (checked) => {
    setSaving(true);
    try {
      const res = await updateSettings({ online_queries_enabled: checked });
      setPublicSettings(res.data?.data ?? { online_queries_enabled: checked });
      showToast(
        checked
          ? "Consultas en línea ACTIVADAS."
          : "Consultas en línea DESACTIVADAS.",
        "success"
      );
    } catch (error) {
      showToast(
        error.response?.data?.message || "No se pudo guardar la configuración.",
        "error"
      );
    } finally {
      setSaving(false);
    }
  };

  return (
    <Grid container justifyContent="center" sx={{ mt: 4 }}>
      <Grid size={{ xs: 12, md: 9, lg: 8 }}>
        <GlassCard>
          <CardHeader
            title="Configuración general"
            description="Parámetros del sistema que afectan a todos los usuarios."
            icon={<PublicOffIcon />}
          />

          <Box
            sx={{
              mt: 2,
              p: 2,
              border: "1px solid",
              borderColor: "divider",
              borderRadius: 2,
              display: "flex",
              alignItems: "flex-start",
              gap: 2,
            }}
          >
            <Box sx={{ flex: 1 }}>
              <Typography sx={{ fontWeight: 700 }}>
                Consultas en línea al Poder Judicial
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Cuando está desactivado, ningún botón que consulte al portal
                (generar novedades, actualizar expediente, generar órdenes de
                pago online, subir demandas online…) funciona. El servidor
                también rechaza esas peticiones.
              </Typography>
              {!onlineQueriesEnabled && (
                <Typography
                  variant="body2"
                  sx={{ mt: 1.5, color: "warning.main", fontWeight: 600 }}
                >
                  Actualmente desactivado. La actualización de datos se hace con
                  el importador local (Novedades → Importar Novedades).
                </Typography>
              )}
            </Box>

            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              {saving && <CircularProgress size={18} />}
              <Switch
                checked={onlineQueriesEnabled}
                disabled={!canEdit || saving}
                onChange={(e) => toggleOnlineQueries(e.target.checked)}
              />
            </Box>
          </Box>

          {!canEdit && (
            <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: "block" }}>
              Necesitás el permiso “administrar configuracion” para cambiar esto.
            </Typography>
          )}
        </GlassCard>
      </Grid>
    </Grid>
  );
}
